import React, { useRef, useEffect, useState } from "react";
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from "mapbox-gl";
import { useAnimation } from "framer-motion";

import * as Styled from "./styles.js";
import useFlyover from "../../../hooks/useFlyover.js";
import { Heading2, Heading5, Paragraph } from "../../Typography/index.js";

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;
mapboxgl.accessToken =
  "pk.eyJ1IjoiZ2lkZW9uanIiLCJhIjoiY2tudmdlZTZhMDJmYTJvbjRiaHpmcHl3ZyJ9.KxGzrM1ZHq9NwEkXOJz7ZA";

const FullscreenFlyoverMap = ({ slideType, duration, ...rest }) => {
  const config = {
    style: "mapbox://styles/mapbox/dark-v10",
    showMarkers: true,
    markerColor: "#848",
    theme: slideType?.[0]?.mapStyle?.style,
    use3dTerrain: false,
    title: slideType?.[0]?.title,
    chapters: slideType?.[0]?.locations?.map((location) => ({
      id: location.id,
      alignment: "right",
      hidden: false,
      title: location.name,
      description: location.description,
      location: {
        center: [location.longitude, location.latitude],
        zoom: 10,
        pitch: 60,
        bearing: 0,
      },
      mapAnimation: "flyTo",
      rotateAnimation: false,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    })),
  };
  const mapContainerRef = useRef(null);
  const map = useRef();
  const [step, setStep] = useState(0);
  const controls = useAnimation();

  useEffect(() => {
    map.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/dark-v10",
      center: config.chapters?.[0]?.location.center,
      zoom: config.chapters?.[0]?.location.zoom,
      // bearing: config.chapters?.[0]?.location.bearing,
      // pitch: config.chapters?.[0]?.location.pitch,
    });

    if (config.showMarkers) {
      const marker = new mapboxgl.Marker({ color: config.markerColor });
      marker
        .setLngLat(config.chapters?.[0]?.location.center)
        .addTo(map.current);
    }

    map.current.once("load", () => {
      map.current.zoomTo(11, { duration: 2000 });
    });

    return () => map.current.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { chapter } = useFlyover(config?.chapters, step, setStep, duration);

  useEffect(() => {
    const marker = new mapboxgl.Marker({ color: config.markerColor });
    marker.setLngLat(chapter?.location?.center).addTo(map.current);

    map.current.flyTo({
      center: chapter?.location?.center,
      speed: 0.75,
      essential: true,
    });
  }, [chapter, config.markerColor, controls]);

  const parent = {
    initial: { x: 800 },
    animate: {
      x: 0,
      transition: {
        staggerChildren: 0.5,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  const child = {
    initial: { x: 800 },
    animate: {
      x: 0,
      transition: {
        duration: 1,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  return (
    <div>
      <Styled.MapSidebar variants={parent} initial="initial" animate="animate">
        <Heading2 variants={child}>{config.title.toUpperCase()}</Heading2>
        <Heading5 variants={child}>{config?.chapters?.[step]?.title}</Heading5>
        <Paragraph variants={child}>
          {config?.chapters?.[step]?.description}
        </Paragraph>
      </Styled.MapSidebar>
      <Styled.MapContainer ref={mapContainerRef} />
    </div>
  );
};

export default FullscreenFlyoverMap;
